module.exports = __webpack_public_path__ + "img/ico-fuwu.f71f651b.jpg";